export default [
  {
    title: "식자재 운반 및 보관",
    list: [
      {
        content: "1. 5kg 이상의 중량물 취급 시 안내표시를 확인한다.",
        isChecked: "",
      },
      {
        content: "2. 운반용 기구는 사용 전 정상 작동여부를 점검한다.",
        isChecked: "",
      },
      {
        content: "3. 운반대차에 과적하거나 편하중이 발생하지 않도록 사용한다.",
        isChecked: "",
      },
      {
        content: "4. 통행로 바닥에 물기·기름기 또는 음식물을 제거한다.",
        isChecked: "",
      },
      {
        content: "5. 운반대차는 사용 후 별도의 장소에 안전하게 보관한다.",
        isChecked: "",
      },
      {
        content: "6. 선반 등 날카로운 부분에 부딪힘·베임 방지를 위한 보호대를 설치한다.",
        isChecked: "",
      },
      {
        content: "7. 선반 위에 물건을 올리거나 내릴 경우  안전한 작업발판을 사용한다.\n※ 바퀴달린 의자 사용, 적재물을 쌓아서 딛는 등의 행위 금지",
        isChecked: "",
      },
      {
        content: "8. 냉장·냉동고에 저온주의 표지를 부착한다.",
        isChecked: "",
      },
      {
        content: "9. 냉장·냉동고 출입문은 내부에서도 열리는지 정기적으로 확인하다.",
        isChecked: "",
      }, {
        content: "10. 냉장·냉동고 내에서 장시간 작업 시 방한복·방한장갑·방한모 등을 지급·착용토록 한다.",
        isChecked: "",
      },
      {
        content: "11. 냉장·냉동고 출입문을 잠그는 경우에는 반드시 내부에 작업자가 있는지 확인한다.",
        isChecked: "",
      },
      {
        content: "12. 덤웨이터에 근로자의 탑승을 금지하며, 적재하중을 초과하지 않는다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "조리",
    list: [
      {
        content: "1. 미끄럼방지화, 앞치마(방수), 방열장갑, 보안경 등 작업에 적합한 개인보호구를 지급·착용한다.",
        isChecked: "",
      },
      {
        content: "2. 가스사용 조리기구는 점화 전 가스누출 유무를 확인한다.\n※ 가스누설경보기 설치 및 작동상태 확인",
        isChecked: "",
      },
      {
        content: "3. 고온, 화상·열상, 넘어짐주의 등의 표지를 부착한다.",
        isChecked: "",
      },
      {
        content: "4. 조리작업이 끝나면 반드시 전원·가스를 차단한다.",
        isChecked: "",
      },
      {
        content: "5. 화구 사용시 크기와 소재가 적합한 조리기구를 사용한다.",
        isChecked: "",
      },
      {
        content: "6. 조리실 환기장치의 작동이 원활하지 않은 경우 창문 및 출입문을 개방하여 주기적으로 환기한다.",
        isChecked: "",
      },
      {
        content: "7. 조리에 적합한 주방설비·기구를 비치하고 지급한다.",
        isChecked: "",
      },
      {
        content: "8. 기름으로 인한 화재를 대비하여 적절한 소화기(K급)를 비치한다.",
        isChecked: "",
      },
      {
        content: "9. 조리용 기구는 적절한 장소에 별도로 보관한다.",
        isChecked: "",
      },
      {
        content: "10. 식품가공용 기계의 방호커버는 조리작업 중 임의로 해체하지 않도록 관리한다.",
        isChecked: "",
      },
    ],
  },
];
